import { defineStore } from "pinia";
import { ref } from "vue";

export const useGeneralInfoStore = defineStore('generalInfo', () => {
    const hideStartMaxPrice = ref(false);

    function setHideStartMaxPrice(value) {
        hideStartMaxPrice.value = value;
    }

    return {
        hideStartMaxPrice,
        setHideStartMaxPrice
    }
});
